import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetchQuestionReplies } from "../../processes/replyProccess";
import Question from "./Question";
import QuestionSearchUnsupported from "./QuestionSearchUnsupported";

function QuestionSearchItemContainer({
  question,
  dispatch,
  currentUser,
}) {
  const isInteractive = question?.format === "interactive";

  useEffect(() => {
    if (!isInteractive && question?.id) {
      fetchQuestionReplies(dispatch, question.id);
    }
  }, [dispatch, question?.id, isInteractive]);

  if (isInteractive) {
    return <QuestionSearchUnsupported question={question} />;
  }

  return (
    <Question
      question={question}
      currentUser={currentUser}
      readOnly
    />
  );
}

export default connect()(QuestionSearchItemContainer);
